import * as yup from 'yup';

export const getTrackerDisplayValidationSchema = () =>
    yup.object({
        trackerName: yup
            .string()
            .max(70)
            .required(),
    });
